import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from "@mui/material";

const GLASS = {
  bg: "linear-gradient(135deg, rgba(18,22,28,.94) 0%, rgba(10,13,17,.94) 100%)",
  border: "1px solid rgba(255,255,255,.08)",
  text: "#e5e7eb",
  subtext: "#9ca3af",
  borderSoft: "1px solid rgba(51,65,85,.8)",
};

const fmtUsd = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return "$0.00";
  const sign = n < 0 ? "-" : "";
  return `${sign}$${Math.abs(n).toFixed(2)}`;
};

function TableContent({ positions = [] }) {
  return (
    <Box sx={{ overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ color: GLASS.subtext, fontWeight: 900, borderColor: "rgba(255,255,255,.08)" }}>
              Market
            </TableCell>
            <TableCell sx={{ color: GLASS.subtext, fontWeight: 900, borderColor: "rgba(255,255,255,.08)" }}>
              Side
            </TableCell>
            <TableCell sx={{ color: GLASS.subtext, fontWeight: 900, borderColor: "rgba(255,255,255,.08)" }}>
              Avg
            </TableCell>
            <TableCell sx={{ color: GLASS.subtext, fontWeight: 900, borderColor: "rgba(255,255,255,.08)" }}>
              Size
            </TableCell>
            <TableCell sx={{ color: GLASS.subtext, fontWeight: 900, borderColor: "rgba(255,255,255,.08)" }}>
              PnL
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {positions.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} sx={{ color: GLASS.subtext, borderColor: "rgba(255,255,255,.08)" }}>
                No open positions yet.
              </TableCell>
            </TableRow>
          ) : (
            positions.map((p) => {
              const pnl = Number(p.pnl || 0);
              return (
                <TableRow key={p.id || `${p.marketId}_${p.side}`}>
                  <TableCell sx={{ color: GLASS.text, borderColor: "rgba(255,255,255,.08)", fontWeight: 800 }}>
                    {p.marketTitle || p.market || p.marketId || "—"}
                  </TableCell>

                  <TableCell sx={{ borderColor: "rgba(255,255,255,.08)" }}>
                    <Chip
                      label={(p.side || "—").toUpperCase()}
                      size="small"
                      sx={{
                        height: 22,
                        borderRadius: 999,
                        fontWeight: 900,
                        fontSize: 11,
                        bgcolor: p.side === "yes" ? "rgba(34,197,94,.18)" : "rgba(216,180,254,.18)",
                        border: GLASS.borderSoft,
                        color: GLASS.text,
                      }}
                    />
                  </TableCell>

                  <TableCell sx={{ color: GLASS.text, borderColor: "rgba(255,255,255,.08)" }}>
                    {fmtUsd(p.avgPrice)}
                  </TableCell>

                  <TableCell sx={{ color: GLASS.text, borderColor: "rgba(255,255,255,.08)" }}>
                    {Number(p.size || 0).toFixed(2)}
                  </TableCell>

                  <TableCell
                    sx={{
                      color: pnl >= 0 ? "#22c55e" : "#f97373",
                      borderColor: "rgba(255,255,255,.08)",
                      fontWeight: 900,
                    }}
                  >
                    {fmtUsd(pnl)}
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </Box>
  );
}

export default function PositionsTable({ positions = [], embedded = false }) {
  if (embedded) return <TableContent positions={positions} />;

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        background: GLASS.bg,
        border: GLASS.border,
        boxShadow: "0 18px 40px rgba(15,23,42,.9)",
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ p: 2.1 }}>
        <Typography sx={{ fontWeight: 950, fontSize: 14, color: GLASS.text, mb: 1 }}>
          Positions
        </Typography>
        <TableContent positions={positions} />
      </CardContent>
    </Card>
  );
}
